import { Model, model, prop } from "mobx-keystone";

@model("collab/PackSize")
class PackSize extends Model({
  id: prop<identifier>(),
  name: prop<string>(),
}) {}

export default PackSize;
